import React, { useEffect, SyntheticEvent } from 'react'
import Dialog from '../base/dialog'
import Icon from '../base/icon'
import type { DialogProps } from '../base/dialog'
import { toolOptions } from './config'
import track from '../track'
import styles from './index.module.less'

interface AIModuleDialogProps extends DialogProps {
  mainUrl: string
  uploadMainUrl?: (mainUrl: string) => string
  visible?: boolean
  onClose?: (e: SyntheticEvent) => any
}

const AIModuleDialog: React.FC<AIModuleDialogProps> = ({ mainUrl, uploadMainUrl, ...props }) => {
  useEffect(() => {
    track.reportCustom('FD_AiTool_Page')
  }, [])

  const renderToolItem = (item: (typeof toolOptions)[0]) => {
    const href = `${item.link}?url=${mainUrl}`
    return (
      <a
        onClick={async () => {
          track.reportCustom('FD_AiToolModule_Click', {
            module1: item.title,
          })
          if (uploadMainUrl) {
            const ossMainUrl = await uploadMainUrl(mainUrl)
            window.open(`${item.link}?url=${ossMainUrl}`)
          } else {
            window.open(`${item.link}?url=${mainUrl}`)
          }
        }}
        key={item.title}
        className={styles.toolItem}
      >
        <div className={styles.mainUrl} style={{ backgroundImage: `url(${item.mainUrl})` }} />
        <div className={styles.title}>
          <div className={styles.titleText}>{item.title}</div>
          <div className={styles.iconList}>
            {[...Array(item.recommendIndex)].map((_, index) => (
              <Icon key={index} type="m-remen_tianchong" />
            ))}
          </div>
        </div>
        <div className={styles.subTitle}>{item.subTitle}</div>
      </a>
    )
  }

  return (
    <Dialog className={styles.aiDialog} centered {...props}>
      <div className={styles.aliDialogBody}>
        <div className={styles.header}>
          <div className={styles.logo} />
          <div className={styles.title}>AI 改款工具</div>
        </div>
        <div className={styles.content}>{toolOptions.map(renderToolItem)}</div>
      </div>
    </Dialog>
  )
}

export default AIModuleDialog
